import { DispatchType } from '../../types/businessTypes';
import { DISPATCH_TYPE_ORDER } from '../../services/fulfillmentsService/helpers';

export const DISPATCH_TYPE_LABEL_KEY: Record<DispatchType, string> = {
  [DispatchType.PICKUP]: 'header_olo.pickup',
  [DispatchType.DELIVERY]: 'header_olo.delivery',
  [DispatchType.DINE_IN]: 'header_olo.dineIn',
};

export const sortByDispatchType = <T extends { type: DispatchType }>(
  items: T[],
): T[] =>
  [...items].sort(
    (a, b) =>
      DISPATCH_TYPE_ORDER.indexOf(a.type) - DISPATCH_TYPE_ORDER.indexOf(b.type),
  );
